/**
 * 测量组件
 * @module MeasureComponent
 */
'use strict';
define([
    '../base/ComponentBase',
    './MeasureComponentExt',
    '../utils/CommonUtil',
    '../utils/RenderUtil',
    '../utils/GeometryUtil',
    '../g2'
], function(
    ComponentBase,
    MeasureComponentExt,
    CommonUtil,
    RenderUtil,
    GeometryUtil,
    g2
) {
    var MEASURE_TAG = '_measure_id';
    /**
     * @constructor
     * @classdesc 测量组件
     * @augments G.base.PureComponent
     * @alias G.components.MeasureComponent
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map} options.map - 必填，地图对象
     * @param　{String} options.layerId - 可选，测量图层id，默认为measure-layer
     * @param {Boolean} options.showTipLink - 可选，是否显示提示连线，默认为true
     * @param {Array} options.styleName -必填，测量显示的样式名，styleName[0]为测量长度的过程点的距离显示样式，styleName[1]为最终测量结果样式
     * @param {Object} options.symbols - 可选，符号配置，需要修改默认符号时设置
     * @param {Object} options.symbols.line - 可选，测量绘制的线符号
     * @param {Object} options.symbols.polygon - 可选，测量绘制的面符号
     * @param {Object} options.symbols.node - 可选，顶点符号
     * @param {Object} options.symbols.delete - 可选，删除的图标符号
     * @param {Function} options.lengthTipFn 可选，设置长度显示的方法
     * @param {Function} options.areaTipFn 可选，设置面积显示的方法
     * @returns {Object} - 实例化的对象
     * @example
     *var symbols={
                //线符号
                "line":{
                    "type": "SimpleFillSymbol",
                    "options": {
                        "borderColor":{
                            "a": 120, "r": 255, "g": 0, "b": 0
                        },
                        "borderThickness": 2,
                        "opacity":1
                    }
                },
                //面符号
                "polygon":{
                    "type": "SimpleFillSymbol",
                    "options": {
                        "borderColor":{
                            "a": 120, "r": 255, "g": 0, "b": 0
                        },
                        "fillColor":{
                            "a": 50, "r": 200, "g": 0, "b": 0
                        },
                        "borderThickness": 2,
                        "opacity":1
                    }
                },
                //顶点符号
                "node":{
                    "type": "SimpleMarkerSymbol",
                    "options": {
                        "style":"circle",
                        "borderColor":{
                            "a": 200, "r": 200, "g": 0, "b": 0
                        },
                        "fillColor":{
                            "a": 250, "r": 255, "g": 255, "b": 255
                        },
                        "borderThickness": 2,
                        "size":4
                    }
                },
                //删除图标符号
                "delete":{
                    type:'PictureMarkerSymbol',
                    options:{
                        "source":"iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAb0lEQVR42mNYfuABHB28sxOIjtzds+bwQ2RxCGKAUP8ZGPAghFIQHz8Aq0ZSCjEDVQVcCptSuGpkLrpSZGkMbdjciqmOYqXEOoAEbxEMLGBMEhMFQGUMkHjHH7EQNQxfP38AojMPjx6+uxsihAsBAMBJhSJg1b4KAAAAAElFTkSuQmCC",
                        "width": 14,
                        "height": 14,
                        "opacity": 1
                    }
                }
            };
     //测距的显示内容，需返回要显示的html字符串
     var lengthTipFn=function(type,length){
        if(!isNaN(length)){
            length=(length/1000).toFixed(2);
        }
        var createHtmlFn={
            //起点
            'start':function(){
                return '起点';
            },
            //中间点
            'node':function(length){
                return length+'公里';
            },
            //终点
            'end':function(length){
                return '总长:'+length+'公里';
            }
        };
        var fn=createHtmlFn[type];
        if(Object.prototype.toString.call(fn)=='[object Function]'){
            return createHtmlFn[type](length);
        }
    }
     //测面积的显示内容，需返回要显示的html字符串
     var areaTipFn=function(length,area){
        length=(length/1000).toFixed(2);
        area=(area/1000000).toFixed(2);
        return '长度:'+length+'公里 <br/>面积:'+area+'平方公里';
    }
     //测量组件
     var measureComponent=new G.components.MeasureComponent({
        map:map,
        symbols:symbols,
        styleName:['emap-measure-node-tooltip','emap-measure-tooltip'],
        lengthTipFn:lengthTipFn,
        areaTipFn:areaTipFn
    });
     */
    var component = ComponentBase.extend({
        options: {
            layerId: 'measure-layer',
            //是否显示连线
            showTipLink: true,
            //符号
            symbols: {
                //线符号
                "line": {
                    "type": "SimpleFillSymbol",
                    "options": {
                        "borderColor": {
                            "a": 120,
                            "r": 255,
                            "g": 0,
                            "b": 0
                        },
                        "borderThickness": 2,
                        "opacity": 1
                    }
                },
                //面符号
                "polygon": {
                    "type": "SimpleFillSymbol",
                    "options": {
                        "borderColor": {
                            "a": 120,
                            "r": 255,
                            "g": 0,
                            "b": 0
                        },
                        "fillColor": {
                            "a": 50,
                            "r": 200,
                            "g": 0,
                            "b": 0
                        },
                        "borderThickness": 2,
                        "opacity": 1
                    }
                },
                //顶点符号
                "node": {
                    "type": "SimpleMarkerSymbol",
                    "options": {
                        "style": "circle",
                        "borderColor": {
                            "a": 200,
                            "r": 200,
                            "g": 0,
                            "b": 0
                        },
                        "fillColor": {
                            "a": 250,
                            "r": 255,
                            "g": 255,
                            "b": 255
                        },
                        "borderThickness": 2,
                        "size": 4
                    }
                },
                //删除图标符号
                "delete": {
                    type: 'PictureMarkerSymbol',
                    options: {
                        "source": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAb0lEQVR42mNYfuABHB28sxOIjtzds+bwQ2RxCGKAUP8ZGPAghFIQHz8Aq0ZSCjEDVQVcCptSuGpkLrpSZGkMbdjciqmOYqXEOoAEbxEMLGBMEhMFQGUMkHjHH7EQNQxfP38AojMPjx6+uxsihAsBAMBJhSJg1b4KAAAAAElFTkSuQmCC",
                        "width": 14,
                        "height": 14,
                        "opacity": 1
                    }
                }
            },
            //样式名
            styleName: ['emap-measure-node-tooltip', 'emap-measure-tooltip'],
            /**
             * 测距的显示
             * @param type
             * @param value
             * @returns {*}
             */
            lengthTipFn: function(type, length) {
                if (!isNaN(length)) {
                    length = (length / 1000).toFixed(2);
                }
                var createHtmlFn = {
                    //起点
                    'start': function() {
                        return '起点';
                    },
                    //中间点
                    'node': function(length) {
                        return length + '公里';
                    },
                    //终点
                    'end': function(length) {
                        return '总长:' + length + '公里';
                    }
                };
                var fn = createHtmlFn[type];
                if (Object.prototype.toString.call(fn) == '[object Function]') {
                    return createHtmlFn[type](length);
                }
            },
            /**
             * 测面的显示
             * @param length
             * @param area
             */
            areaTipFn: function(length, area) {
                length = (length / 1000).toFixed(2);
                area = (area / 1000000).toFixed(2);
                return '周长:' + length + '公里 <br/>面积:' + area + '平方公里';
            }
        },
        initialize: function(options) {
            ComponentBase.prototype.initialize.call(this, options);
            //当前工具
            this._measuringTool = null;
            //当前测量
            this._measuringObj = null;
            //保存所有测量
            this._measures = {};
            //
            this._initialize();
            //
            this.map.listen('click', this._clickHandler, this);
        },
        destroy: function() {
            //
            this.clear();
            //
            this.map.removeLayer(this._drawLayer);
            this.map.removeLayer(this._measureLayer);
            //
            this.map.off('click', this._clickHandler);
            //
            ComponentBase.prototype.destroy.call(this);
        }
    });
    /**
     * 内部方法
     */
    component.include({
        _initialize: function() {
            /**
             * 默认获取图层，获取不到则自动创建
             * @type {*}
             */
            var drawLayer = this.map.getLayerById(this.options.layerId + '-draw');
            if (!drawLayer) {
                drawLayer = new g2.carto.ElementLayer({
                    id: this.options.layerId + '-draw'
                });
                this.map.addLayer(drawLayer);
            }
            var measureLayer = this.map.getLayerById(this.options.layerId);
            if (!measureLayer) {
                measureLayer = new g2.carto.ElementLayer({
                    id: this.options.layerId
                });
                this.map.addLayer(measureLayer);
            }
            this._drawLayer = drawLayer;
            this._measureLayer = measureLayer;
            //
            this._toolTipWare = new g2.widget.TooltipWare({
                map: this.map
            });
            //顶点符号
            this._nodeSymbol = RenderUtil.object2Symbol(
                this.options.symbols.node.type,
                this.options.symbols.node.options
            );
            //删除按钮符号
            this._deleteSymbol = RenderUtil.object2Symbol(
                this.options.symbols.delete.type,
                this.options.symbols.delete.options
            );
            //
            this._createTools();
        },
        _clickHandler: function(event) {
            var screenX = event.screenX,
                screenY = event.screenY;
            var ele = this._measureLayer.hitTest(screenX, screenY);
            if (ele && MEASURE_TAG in ele.element) {
                var measureObj = this._measures[ele.element[MEASURE_TAG]];
                this._clearMeasure(measureObj);
            }
        },
        /**
         * 清除当前测量状态
         * @private
         */
        _clearMeasuring: function() {
            this._drawLayer.clear();
            if (this._measuringTool) {
                delete this._measuringTool[MEASURE_TAG];
            }
            this._measuringTool = null;
            if (this._measuringObj) {
                this._clearMeasure(this._measuringObj);
            }
            this._measuringObj = null;
            //
            this._ellipseElement = null;
            delete this._ellipseElement;
        },
        //清除测量结果
        _clearMeasure: function(measureObj) {
            if (CommonUtil.isObject(measureObj)) {
                //remove elements
                var ele = measureObj.element,
                    nodes = measureObj.nodes,
                    tips = measureObj.tooltips,
                    deleteEle = measureObj.deleteEle,
                    linkEle = measureObj.linkEle;
                if (ele) {
                    this._measureLayer.remove(ele);
                }
                if (deleteEle) {
                    this._measureLayer.remove(deleteEle);
                }
                if (linkEle) {
                    this._measureLayer.remove(linkEle);
                }
                for (var i = 0, len = nodes.length; i < len; i++) {
                    if (nodes[i]) {
                        this._measureLayer.remove(nodes[i]);
                    }
                }
                for (var i = 0, len = tips.length; i < len; i++) {
                    this._toolTipWare.remove(tips[i].id);
                }
            }
        }
    });
    /**
     * 对外接口
     */
    component.include({
        /**
         * 测量距离
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        measureLength: function() {
            this.cancel();
            this._measuringTool = this._lineTool;
            this._measuringTool.onClick();
            //定义测量的id
            this._measuringTool[MEASURE_TAG] = CommonUtil.newUUID32();
        },
        /**
         * 测量面积
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        measureArea: function() {
            this.cancel();
            this._measuringTool = this._polygonTool;
            this._measuringTool.onClick();
            //定义测量的id
            this._measuringTool[MEASURE_TAG] = CommonUtil.newUUID32();
        },
        /**
         * 测量圆
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        measureCircle: function() {
            this.cancel();
            this._measuringTool = this._circleTool;
            this._measuringTool.onClick();
            //定义测量的id
            this._measuringTool[MEASURE_TAG] = CommonUtil.newUUID32();
        },
        /**
         * 测量椭圆
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        measureEllipse: function() {
            this.cancel();
            this._measuringTool = this._ellipseTool;
            this._measuringTool.onClick();
            //定义测量的id
            this._measuringTool[MEASURE_TAG] = CommonUtil.newUUID32();
        },
        /**
         * 完成测量
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        finish: function() {
            if (this._measuringTool) {
                try {
                    this._measuringTool.onEndDraw();
                } catch (e) {
                    throw (new Error('结束异常！error=' + e.message));
                }
            } else {
                throw (new Error('当前无测量！'));
            }
        },
        /**
         * 取消测量状态
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        cancel: function() {
            this._noopTool.onClick();
            this._clearMeasuring();
        },
        /**
         * 清除测量
         * @method
         * @memberOf G.components.MeasureComponent.prototype
         */
        clear: function() {
            this._drawLayer.clear();
            this._measureLayer.clear();
            this._toolTipWare.clear();
        }
    });
    //
    MeasureComponentExt.extend(component, MEASURE_TAG);
    return component;
});